let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aAfbH")).then(() => parcelRequire('gE9ms'));